import React, { Fragment } from 'react'
import Slider from 'react-slick'
import get from 'lodash/get'
import PropTypes from 'prop-types'

import { userCheckMobileScreen } from 'helpers/tools'
import Typography from 'components/atoms/Typography'
import CustomModal from 'components/molecules/CustomModal'

import './ModalImage.scss'

const setting = {
  arrows: false,
  dots: false,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: false,
}

function ModalImage({ images, slickRef, openState }) {
  const isMobile = userCheckMobileScreen()
  const [openImage, setOpenImage] = openState

  return (
    <CustomModal
      className="image-modal"
      size="lg"
      open={openImage}
      closeModal={() => setOpenImage(false)}
      minimizeMobile
    >
      <Slider ref={slickRef} {...setting}>
        {images?.map(({ image, title, subtitle }, index) => (
          <Fragment key={index}>
            <div className="d-flex justify-content-between image-modal__content">
              <button onClick={() => slickRef.current.slickPrev()}>
                <i className="icone-chevron-left" />
              </button>
              <img
                src={isMobile ? get(image, 'medium.url') : get(image, 'wide.url')}
                alt={get(image, 'alt')}
                className="image-modal__image"
              />
              <button onClick={() => slickRef.current.slickNext()}>
                <i className="icone-chevron-right" />
              </button>
            </div>
            <div className="d-flex align-items-center flex-column">
              <Typography cssClass="lightbox__title">{title}</Typography>
              <Typography cssClass="lightbox__subtitle mb-2">{subtitle}</Typography>
            </div>
          </Fragment>
        ))}
      </Slider>
    </CustomModal>
  )
}

ModalImage.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        medium: PropTypes.shape({ url: PropTypes.string }).isRequired,
        wide: PropTypes.shape({ url: PropTypes.string }).isRequired,
        title: PropTypes.string,
        subtitle: PropTypes.string,
      }),
      subtitle: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  openState: PropTypes.any,
  slickRef: PropTypes.object,
}

export default ModalImage
